import { ReactComponent as LogoImg } from "@/assets/img/logo.svg";

function Logo(props: React.SVGProps<SVGSVGElement>) {
  return <LogoImg {...props} />;
}

export default Logo;
